export const LOGHI_ECOSISTER = [
  {link: "https://firebasestorage.googleapis.com/v0/b/pinbike-1521450884928.appspot.com/o/utils%2Flogo%20ecosister.png?alt=media&token=e5fdb9a7-5759-46d1-9c6d-4b11221ddcdc", key: "logo-ecosister"},
  {link: "https://firebasestorage.googleapis.com/v0/b/pinbike-1521450884928.appspot.com/o/utils%2FLogo_Italia%20Domani.jpg?alt=media&token=76760af2-7ac7-4c29-bdb1-30a8a337595f", key: "logo-italia-domani"},
  {link: "https://firebasestorage.googleapis.com/v0/b/pinbike-1521450884928.appspot.com/o/utils%2FMINISTEROUR.png?alt=media&token=569455b7-4574-4848-822f-6ed417e066e3", key : "logo-MINISTEROUR"},
  {link: "https://firebasestorage.googleapis.com/v0/b/pinbike-1521450884928.appspot.com/o/utils%2FLogo-Fin-Ngeu.png?alt=media&token=f17568f6-dea1-4a55-85df-b8f34dfa6392", key: "logo-fin-ngeu"}
];

export const LOGHI_GREENRIDE = [
];

export const LOGHI_SIAMUS = [
  LOGHI_ECOSISTER[1],
  LOGHI_ECOSISTER[2],
  LOGHI_ECOSISTER[3],
  {link: "https://firebasestorage.googleapis.com/v0/b/pinbike-1521450884928.appspot.com/o/utils%2Flogo-uniba.png?alt=media&token=fb8d5d41-19fb-4b83-9bb1-3964789c4560", key: "logo-uniba"},
  {link: "https://firebasestorage.googleapis.com/v0/b/pinbike-1521450884928.appspot.com/o/utils%2Flogo-grins.jpg?alt=media&token=30998975-88f5-4c07-a8b0-a3094e186822", key: "logo-grins"}
];